export default __webpack_public_path__ + "static/sandataedu-0dae06a20ce8041fb65294ce49c86ee8.png";